<template>
    <div class="auto-mount-point">
        <template v-for="name in states.loopForNames">
            <component
                :is="convert(name)"
                v-if="states.attrMap[name].vIf"
                :key="name"
                v-bind="states.attrMap[name].$props"
                v-on="states.attrMap[name].$listeners"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
import { AutoMountModel } from '@/services/auto-mount/auto-mount-manager';
import { injectService } from '@patsnap/tahiti-core';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import { defineAsyncComponent, ref } from 'vue';

const service = injectService<AutoMountModel>(AutoMountModel);

const { disposes } = useDisposes();

const states = ref(service.modelData);

const cache = new Map<string, unknown>();

function convert(name: string) {
    if (cache.has(name)) {
        return cache.get(name);
    }

    const componentMap = states.value.componentMap;

    const result = defineAsyncComponent(componentMap[name]);
    cache.set(name, result);
    return result;
}

disposes.push(
    service,
    service.onStatesChange((value) => {
        states.value = value;
    }),
);
</script>
